import { supabase } from '@/lib/supabase';
import { toUserMessage } from '@/lib/errors';
import { log } from '@/lib/logger';
import { ok, err, type ApiResponse } from './_base';

export async function signIn(
  email: string,
  password: string,
): Promise<ApiResponse<{ userId: string }>> {
  const { data, error } = await supabase.auth.signInWithPassword({
    email: email.trim(),
    password,
  });
  if (error) {
    log('warn', 'auth.signIn', error.message, { email });
    return err('AUTH_FAILED', toUserMessage(error));
  }
  if (!data.user) {
    return err('AUTH_FAILED', 'No se pudo iniciar sesión. Probá de nuevo.');
  }
  return ok({ userId: data.user.id });
}

export async function signOut(): Promise<ApiResponse<null>> {
  const { error } = await supabase.auth.signOut();
  if (error) {
    log('error', 'auth.signOut', error.message);
    return err('SIGNOUT_FAILED', toUserMessage(error));
  }
  return ok(null);
}
